import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Helmet } from "react-helmet";

import "./ArtistPage.less";

import ArtistContainer from "../../Containers/ArtistContainer";
import ArtistTracksContainer from "../../Containers/ArtistTracksContainer";
import Collapse from "react-bootstrap/Collapse";

import JukeboxPlayArtist from "./JukeboxPlayArtist";
import ArtistAddFavorite from "./ArtistAddFavorite";

import ArtistBanner from "./ArtistBanner";

const ArtistPage = (props) => {
  const [fileUnderOpen, setFileUnderOpen] = useState(false)



  return (
    <React.Fragment>
      <ArtistContainer
        artist={props.match.params.artistSlug}
        render={({ artist, loading, failure }) => {
          if (failure) {
            return (
              <div>
                We are having trouble finding this artist. Best bet for now is to <Link to="/search">search</Link> and find all the tracks
                by this artist.
              </div>
            );
          }
          const { artist: artistName, id: artistId } = artist.artist;

          return (
            <div className="artist-page-component">
              <Helmet>
                <title>{artistName} | Dream Chimney</title>
                <link rel="canonical" href={`https://www.dreamchimney.com/tracks/artists/${props.match.params.artistSlug}`} />
              </Helmet>
              <Row>
                <Col xs={12}></Col>
              </Row>

              <Row className="header-info with-col-list">
                <Col xs={12} sm={8}>
                  {artist.genres && (
                    <div>
                      <div>
                        <h1 className="page-header">
                          <span>{!loading && <div>{artistName}</div>}</span>
                        </h1>
                        <div>Posted {artist.total_tracks > 1 ? artist.total_tracks + " times" : "1 time"}</div>
                      </div>
                      <div className="file-unders">
                        File Under:{" "}
                        {artist.genres &&
                          Object.keys(artist.genres).map((id, index) => {
                            const { genre_id, genre } = artist.genres[id];
                            return (
                              <span key={id}>
                                {index > 10 && (
                                  <Collapse in={fileUnderOpen}>
                                    <Link to={`/genre/${genre_id}`}>{genre}</Link>
                                  </Collapse>
                                )}
                                {index === 10 && !fileUnderOpen && (
                                  <span className="showMore" onClick={() => setFileUnderOpen(!fileUnderOpen)}>
                                    more...
                                  </span>
                                )}
                                {index < 10 && <Link to={`/genre/${genre_id}`}>{genre}</Link>}

                                {index === Object.keys(artist.genres).length - 1 && fileUnderOpen && (
                                  <span className="showMore" onClick={() => setFileUnderOpen(!fileUnderOpen)}>
                                    less
                                  </span>
                                )}
                              </span>
                            );
                          })}
                      </div>
                    </div>
                  )}
                </Col>
                <Col xs={12} sm={4} className="header-right">
                  {artist.alt.length > 0 && (
                    <div class="artist-also totd-box">
                      <div>
                        <strong>Also referred to as:</strong>
                      </div>
                      <ul>
                        {artist.alt.map((a, index) => (
                          <li key={a.id}>
                            {a.artist}
                            {index !== artist.alt.length - 1 ? ", " : ""}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {artist.alt.length === 0 && <div className="missing-also" />}
                  <ArtistAddFavorite artistId={artistId} artistName={artistName} />
                  <JukeboxPlayArtist totalTracks={artist.total_tracks} artistIds={artistId && [...artist.alt.map((a) => a.id), artistId]} />
                </Col>
              </Row>

            </div>
          );
        }}
      />
      <ArtistTracksContainer filter={props.match.params.artistSlug} render={(items) => items} />
      <Row>
        <Col xs={12}>
          <ArtistBanner artistSlug={props.match.params.artistSlug} />
        </Col>
      </Row>


    </React.Fragment >
  );

}

export default ArtistPage;
